import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Converts a number of seconds into a localized human-readable duration string.
 *
 * Examples (en):
 *   3661 → "1 h 1 min 1 sec"
 *   134  → "2 min 14 sec"
 *   45   → "45 sec"
 *   0    → "0 sec"
 *
 * Reacts to language changes automatically (pure: false).
 *
 * Usage:  {{ seconds | duration }}
 */
@Pipe({
  name: 'duration',
  standalone: true,
  pure: false, // re-evaluates on every change-detection cycle → reacts to lang switch
})
export class DurationPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(seconds: number | null | undefined): string {
    if (seconds == null || isNaN(seconds)) return '—';

    const total = Math.floor(Math.abs(seconds));
    const h = Math.floor(total / 3600);
    const m = Math.floor((total % 3600) / 60);
    const s = total % 60;

    const hLabel = this.translate.instant('TIME.HOUR');
    const mLabel = this.translate.instant('TIME.MIN');
    const sLabel = this.translate.instant('TIME.SEC');

    if (h > 0) return `${h} ${hLabel} ${m} ${mLabel} ${s} ${sLabel}`;
    if (m > 0) return `${m} ${mLabel} ${s} ${sLabel}`;
    return `${s} ${sLabel}`;
  }
}
